require("!!/home/ubuntu/nflow/node_modules/mocha-loader/web.js");
if(typeof window !== 'undefined' && window.initMochaPhantomJS) { window.initMochaPhantomJS(); }
mocha.setup({"ui":"bdd"});
require("!!/home/ubuntu/nflow/node_modules/babel-loader/lib/index.js!/home/ubuntu/nflow/test/tests.js")
require("!!/home/ubuntu/nflow/node_modules/mocha-loader/start.js");
if(module.hot) {
	module.hot.accept();
	module.hot.dispose(function() {
		mocha.suite.suites.length = 0;
		var stats = document.getElementById('mocha-stats');
		var report = document.getElementById('mocha-report');
		stats && stats.parentNode.removeChild(stats);
		report && report.parentNode.removeChild(report);
	});
}


//////////////////
// WEBPACK FOOTER
// ./~/mocha-loader!./test/tests.js
// module id = 88
// module chunks = 3